<!-- Cycle and Barn selectors-->
<mat-toolbar>
  <mat-toolbar-row class="mat-toolbar__left screen-only">
    <ng-container>
      <div
        class="flex--column spacing--margin-right item-selector screen-only"
        *ngIf="(sortedCycles$ | async)?.length > 0"
      >
        <mat-label class="text--small text--gray">
          {{ 'cycle-overview.cycle' | translate }}
        </mat-label>
        <mat-select
          [hideSingleSelectionIndicator]="true"
          class="text--small"
          [(ngModel)]="selectedCycleId"
          placeholder="{{ 'cycle-overview.placeholder' | translate }}"
          data-test="cycle-overview-detailed__cycle-selector"
          (selectionChange)="changeCycleSelection($event)"
        >
          <mat-option *ngFor="let cycle of sortedCycles$ | async" [value]="cycle.id">
            {{ cycle.cycleNumber }}
            {{ !!cycle.cycleDate ? '(' + (cycle.cycleDate | agrDate: 'dd-MM-yyyy') : '' }}
            {{
              !!cycle.cycleEndDate
                ? '-' + (cycle.cycleEndDate | agrDate: 'dd-MM-yyyy' + ')')
                : !!cycle.cycleDate
                  ? ')'
                  : ''
            }}
          </mat-option>
        </mat-select>
      </div>
      <div class="flex--column item-selector screen-only">
        <mat-label class="text--small text--gray">
          {{ 'cycle-overview.barn' | translate }}
        </mat-label>
        <mat-select
          [hideSingleSelectionIndicator]="true"
          multiple
          #barnSelector
          class="text--small"
          placeholder="{{ 'cycle-overview.placeholder' | translate }}"
          data-test="cycle-overview__barn-selector"
          [(ngModel)]="selectedBarns"
          (selectionChange)="changeBarnSelection($event)"
        >
          <mat-option *ngFor="let barn of barnOptions" [value]="barn">
            {{ barn.name }} ({{ barn.surfaceArea }}m2)
          </mat-option>
        </mat-select>
      </div>

      <div *ngIf="printButtonIsVisible()" class="mat-toolbar__right screen-only">
        <button
          mat-flat-button
          [matMenuTriggerFor]="downloadMenu"
          data-test="cycle-overview__download-pdf"
        >
          <mat-icon>print</mat-icon><mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
        </button>
        <mat-menu class="screen-only" #downloadMenu>
          <button
            mat-menu-item
            (click)="weeklyReportPrintComponent.printWeeklyReport()"
            data-test="cycle-overview__download-weekly-report-button"
          >
            <mat-icon>leaderboard</mat-icon>
            <span>{{ 'cycle-overview.download-weekly-report' | translate }}</span>
          </button>
        </mat-menu>
      </div>
    </ng-container>
  </mat-toolbar-row>
</mat-toolbar>

<agr-print-page
  class="print-only"
  orientation="landscape"
  [customizedLogoSrc]="customizedLogoSrc"
  [showAgrifirmLogo]="showAgrifirmLogo"
>
  <app-weekly-report-print
    [customer]="customer$ | async"
    [location]="location$ | async"
    [wdoDataSeries]="wdoDataSeries$ | async"
    [refValSheetDataSeries]="refValSheetDataSeries$ | async"
    [observations]="observations$ | async"
    [cycle]="selectedCycle"
    [barns]="barnOptions"
  ></app-weekly-report-print>
</agr-print-page>

<!-- Feed Advice and Reference Value Sheet  section-->

<div class="wrapper--spacing-vertical screen-only">
  <div *ngIf="selectedCycle" class="spacing--margin-horizontal spacing--margin-top">
    <agr-summary-card
      [title]="'within-cycle-performance.advice_and_reference-value-sheet' | translate"
      [canExpand]="true"
      [actions]="cycleGeneralAction$ | async"
    >
      <div class="flex--row flex--nowrap">
        <div
          class="flex--column layout--padding-right min-column-width-110"
          data-test="cycle-overview-dayOldChick__arrivalDate"
        >
          <div class="text--small text--gray">{{ 'app.feed-advice' | translate }}</div>
          <div data-test="selected-feed-advice">
            <a
              *ngIf="selectedFeedAdvice; else none"
              [routerLink]="['/feed-advice', 'view', selectedFeedAdvice.id]"
            >
              {{ selectedFeedAdvice?.name }}
            </a>
            <ng-template #none>{{ 'none' | translate }}</ng-template>
          </div>
        </div>
        <div
          class="flex--column layout--padding-right min-column-width-110"
          data-test="cycle-overview-dayOldChick__birthDate"
        >
          <div class="text--small text--gray">{{ 'app.reference-value-sheet' | translate }}</div>
          <div data-test="selected-rvs">
            <a
              *ngIf="selectedReferenceValueSheet; else none"
              [routerLink]="['/reference-value-sheet', 'view', selectedReferenceValueSheet.id]"
            >
              {{ selectedReferenceValueSheet?.name }}
            </a>
            <ng-template #none>{{ 'none' | translate }}</ng-template>
          </div>
        </div>
      </div>
    </agr-summary-card>
  </div>
  <!-- ARRIVAL PANEL -->
  <app-cycle-overview-detailed-panel
    *ngIf="selectedCycle && selectedBarns.length > 0"
    panelSubject="day-old-chick"
    [selectedCycle]="selectedCycle"
    [hasItems]="false"
    [isMobile]="isMobile$ | async"
    [showAddButton]="false"
    data-test="panel--day-old-chick"
  >
    <table class="table-m">
      <thead>
        <tr>
          <th class="col-width-120">{{ 'cycle-overview.panel.date' | translate }}</th>
          <th class="col-width-120">{{ 'cycle-overview.panel.birthdate' | translate }}</th>
          <th class="col-width-120">{{ 'barn' | translate }}</th>
          <th class="col-width-60">{{ 'cycle-overview.panel.amount' | translate }}</th>
          <th class="col-width-120">
            {{ 'feed-advice.create.table-header.chickenWeightInGrams' | translate }}
          </th>
          <th class="col-width-60">{{ 'breed' | translate }}</th>
          <th class="col-width-60"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let dayOldChick of dayOldChicks">
          <td class="col-width-120">{{ dayOldChick.arrivalDate | agrDate: 'dd-MM-yyyy' }}</td>
          <td class="col-width-120">{{ dayOldChick.chickBirthDate | agrDate: 'dd-MM-yyyy' }}</td>
          <td class="col-width-120">{{ dayOldChick.barn.name }}</td>
          <td class="col-width-60">{{ dayOldChick.amountOfChicks }}</td>
          <td class="col-width-120">{{ dayOldChick.chicksWeightInGrams }}</td>
          <td class="col-width-60">{{ dayOldChick.breed.name }}</td>
          <td class="col-width-60">
            <a
              href
              mat-flat-button
              [routerLink]="['/cycle', selectedCycle.id, 'day-old-chick', dayOldChick.id]"
            >
              <mat-icon>arrow_forward</mat-icon>
              {{ 'cycle-overview.edit' | translate }}
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </app-cycle-overview-detailed-panel>

  <!-- WEEK REGISTRATIONS PANEL -->
  <app-cycle-overview-detailed-panel
    *ngIf="selectedCycle && shouldShowObservationsPanel$ | async"
    panelSubject="daily-performance"
    [selectedCycle]="selectedCycle"
    [isMobile]="isMobile$ | async"
    [showAddButton]="false"
    data-test="panel--daily-performance"
  >
    <div class="spacing--margin-half-bottom">
      <span
        class="float-left"
        *ngIf="selectedCycle?.dayOldChicks?.length > 0; else noRegistrations"
      >
        <button
          mat-button
          (click)="openWeekRegistrations(selectedCycle)"
          data-test="panel--daily-performance__edit-current-week"
        >
          <mat-icon>create</mat-icon>
          {{ 'cycle-overview.panel.edit-current-week' | translate }}
        </button>
        <button
          mat-button
          (click)="openWeekRegistrationsOverview(selectedCycle)"
          data-test="panel--daily-performance__weekregistration-overview"
        >
          <mat-icon>assignment</mat-icon>
          {{ 'cycle-overview.weekregistration-overview' | translate }}
        </button>
        <button
          mat-flat-button
          class="spacing--margin-right"
          (click)="downloadTemplate()"
          data-test="panel--daily-performance__upload"
        >
          <mat-icon>file_download</mat-icon>
          {{ 'cycle-overview.weekregistration-download' | translate }}
        </button>
        <button mat-button (click)="uploadCSV()" data-test="panel--daily-performance__upload">
          <mat-icon>cloud_upload</mat-icon>
          {{ 'cycle-overview.weekregistration-upload' | translate }}
        </button>
      </span>
      <ng-template #noRegistrations>
        <div class="text--small text--bold" data-test="panel--daily-performance__empty">
          {{ 'cycle-overview.daily-performance-empty.title' | translate }}
        </div>
        <div class="text--small text--gray">
          {{ 'cycle-overview.daily-performance-empty.description' | translate }}
        </div>
      </ng-template>
    </div>
    <agr-extended-notification
      *ngIf="showCycleStartInFutureWarning"
      notificationType="warning"
      [title]="'cycle-overview.cycle-start-in-future-warning-title' | translate"
      [message]="'cycle-overview.cycle-start-in-future-warning-description' | translate"
    >
    </agr-extended-notification>
  </app-cycle-overview-detailed-panel>

  <!-- KPI SELECTION-->
  <div class="spacing--margin-horizontal spacing--margin-top" *ngIf="selectedCycle">
    <agr-summary-card [title]="'farmer-insights.kpis-name' | translate" [canExpand]="false">
      <div>
        <mat-form-field class="spacing--margin-right">
          <mat-label class="text--small text--gray">
            {{ 'farmer-insights.kpis-name' | translate }}
          </mat-label>
          <mat-select
            [hideSingleSelectionIndicator]="true"
            class="text--small"
            data-placeholder="{{ 'within-cycle-performance.kpi' | translate }}"
            (selectionChange)="onKpiChange($event.value)"
            [value]="selectedKpi$ | async"
            data-test="kpi-selection"
          >
            <mat-option *ngFor="let kpi of nonCumulativeKpis" [value]="kpi">
              {{ 'within-cycle-performance.kpis.' + kpi.kpi.toString() | translate }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-slide-toggle
          [hideIcon]="true"
          data-test="cumulative-toggle"
          [disabled]="!(selectedKpi$ | async)?.hasCumulativeOption"
          color="primary"
          [ngModel]="isCumulativeKpisSelected$ | async"
          (ngModelChange)="isCumulativeKpisSelected$.next($event)"
          class="text--small flex__child--auto align-self-center"
          labelPosition="after"
        >
          {{ 'farmer-insights.aggregation.Sum' | translate }}
        </mat-slide-toggle>
      </div>
      <div *ngIf="isLineChartVisible">
        <agr-chart
          *ngIf="!isEmptyLineSeries; else noLinesSeriesData"
          #lineChart
          [dataSource]="lineChartDataSeries"
          [options]="lineTimeSeriesOptions"
          data-test="kpi-chart"
        ></agr-chart>
        <ng-template #noLinesSeriesData>
          <agr-notification-empty
            [isEmpty]="true"
            [emptyTitle]="'within-cycle-performance.no-data' | translate"
            emptyImage="assets/images/balance.jpg"
          ></agr-notification-empty>
        </ng-template>
      </div>
      <div *ngIf="isColumnChartVisible">
        <agr-chart
          *ngIf="!isEmptyColumnSeries; else noColumnSeriesData"
          #columnChart
          [dataSource]="columnChartDataSeries"
          [options]="columnTimeSeriesOptions"
          data-test="kpi-chart"
        ></agr-chart>
        <ng-template #noColumnSeriesData>
          <agr-notification-empty
            [isEmpty]="true"
            [emptyTitle]="'within-cycle-performance.no-data' | translate"
            emptyImage="assets/images/balance.jpg"
          ></agr-notification-empty>
        </ng-template>
      </div>
    </agr-summary-card>
  </div>
</div>
